<template>
  <div
    v-if="dsComponentDetails.version === VersionOptions.LEGACY"
    :class="classes"
    :data-sb-automation="$attrs['data-sb-automation'] || 'current'"
    data-sb-regression="sb-panel"
  >
    <div
      v-if="showIcon"
      class="icon-wrapper"
      data-sb-automation="panel-icon"
      :class="`icon-wrapper--${iconOrientation}`"
    >
      <i
        aria-hidden="true"
        :class="icon"
      />
    </div>
    <!--
      @slot slot to show contents of the panel
    -->
    <slot />
  </div>
  <SbPanelNext
    v-else
    :icon-orientation="iconOrientation"
    :variation="variation"
    :data-sb-automation="$attrs['data-sb-automation'] || 'panel-next'"
  >
    <template #default>
      <slot />
    </template>
  </SbPanelNext>
</template>

<script>
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbPanelNext from '@src/components/Panel/SbPanelNext.vue';

/**
 * Panels are content containers. They have similar functions to cards,
 * but are bigger.
 * The panel markup is intentionally left as minimal as possible.
 * The organization of the body of the panel is left up to the consumer.
 * An example of how to do a panel with a subpanel is in storybook.
 */
export default {
  name: 'SbPanel',
  components: {
    SbPanelNext,
  },
  mixins: [versionedComponentsMixin],
  props: {
    /**
     * Style variation for the panel.
     * This determines things like padding, and background color.
     * `default|sub|warning|bare`
     */
    variation: {
      type: String,
      default: 'default',
      validator: (value) => value.match(/(default|sub|warning|danger|info|success|bare)/),
    },
    /**
     * Orientation of the icon relative to the content
     * `default|sub|warning|bare`
     */
    iconOrientation: {
      type: String,
      default: 'center|start|end',
      validator: (value) => value.match(/(center|start|end)/),
    },
  },
  computed: {
    classes() {
      return ['sb-panel', `sb-panel-${this.variation}`];
    },
    showIcon() {
      return this.variation.match(/(warning|danger|info|success)/);
    },
    icon() {
      const iconMap = {
        info: 'sb-icon-info',
        success: 'sb-icon-checkmark-outline',
        warning: 'sb-icon-alert-circle',
        danger: 'sb-icon-alert-triangle',
      };
      return iconMap[this.variation];
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@src/components/Panel/style/sb-panel.scss';
</style>
